import { useApolloClient } from '@apollo/client'
import { Dialog } from '@factorialco/f0-react/dist/experimental'
import {
  EngagementDeleteSurveyDocument,
  EngagementSurveysDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  surveyId: number
  onSuccess: () => void
  onCancel: () => void
}

export function DeleteSurveyDialog({ surveyId, onSuccess, onCancel }: Props) {
  const apolloClient = useApolloClient()
  const [deleteSurvey] = useMutation(EngagementDeleteSurveyDocument, {
    extractorFn: (data) => data.surveysMutations.deleteSurveysSurvey,
    refetchQueries: [EngagementSurveysDataCollectionDocument],
  })

  return (
    <Dialog
      onClose={onCancel}
      actions={{
        primary: {
          label: i18n.t('common.delete'),
          variant: 'critical',
          onClick: async () => {
            const response = await deleteSurvey({
              variables: {
                surveyId,
              },
            })

            const handled = handleResult(response, () => {})

            if (handled.success) {
              onSuccess()
              apolloClient.cache.evict({
                id: apolloClient.cache.identify({
                  id: surveyId,
                  __typename: 'SurveysSurvey',
                }),
              })
            }
          },
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: onCancel,
        },
      }}
      header={{
        title: i18n.t('surveys.delete_survey_dialog.title'),
        description: i18n.t('surveys.delete_survey_dialog.description'),
        type: 'critical',
      }}
      open
    />
  )
}
